export const isiPhone = navigator.userAgent.match(/iPhone/i);
